// extracted by mini-css-extract-plugin
module.exports = {"productListWrapper":"ProductListView_productListWrapper__DlM_r"};